import React from 'react';
import Input from '../../../components/ui/Input';

const ProductBusinessForm = ({ formData, onUpdate }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Total SKUs"
          type="number"
          placeholder="Enter number"
          value={formData?.totalSKUs || ''}
          onChange={(e) => onUpdate({ totalSKUs: e?.target?.value })}
          required
        />

        <Input
          label="Best-Selling Product"
          type="text"
          placeholder="Product name"
          value={formData?.bestSellingProduct || ''}
          onChange={(e) => onUpdate({ bestSellingProduct: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Lowest-Selling Product"
          type="text"
          placeholder="Product name"
          value={formData?.lowestSellingProduct || ''}
          onChange={(e) => onUpdate({ lowestSellingProduct: e?.target?.value })}
          required
        />

        <Input
          label="Inventory Turnover Rate (Times/Year)"
          type="number"
          placeholder="e.g., 6"
          value={formData?.inventoryTurnover || ''}
          onChange={(e) => onUpdate({ inventoryTurnover: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Monthly Production Capacity (Units)"
          type="number"
          placeholder="Enter units"
          value={formData?.monthlyProductionCapacity || ''}
          onChange={(e) => onUpdate({ monthlyProductionCapacity: e?.target?.value })}
          required
        />

        <Input
          label="Return Rate (%)"
          type="number"
          placeholder="e.g., 2.5"
          value={formData?.returnRate || ''}
          onChange={(e) => onUpdate({ returnRate: e?.target?.value })}
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="Gross Margin Per Product (%)"
          type="number"
          placeholder="e.g., 45"
          value={formData?.grossMargin || ''}
          onChange={(e) => onUpdate({ grossMargin: e?.target?.value })}
          required
        />

        <Input
          label="Stock-Out Frequency (Times/Month)"
          type="number"
          placeholder="Enter number"
          value={formData?.stockOutFrequency || ''}
          onChange={(e) => onUpdate({ stockOutFrequency: e?.target?.value })}
          required
        />
      </div>

      <div className="p-4 bg-primary/10 border border-primary/20 rounded-md">
        <div className="flex items-start gap-3">
          <div className="p-2 bg-primary/20 rounded-md">
            <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">System Calculations</p>
            <p className="text-xs text-muted-foreground mt-1">
              Based on your inputs, we'll calculate: Demand pattern, Inventory risk, Margin forecasting, and Product concentration risk
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductBusinessForm;